import {createI18nScope} from 'common/i18n/scope';

const __i18nScope = createI18nScope(`common.report`, {
  'reports.actions.exports.export-complete': `Export Complete`,
  'reports.actions.exports.export-failed': `Export Failed`,
  'reports.chart-types.bar': `Bar`,
  'reports.chart-types.column': `Column`,
  'reports.chart-types.flows': `User Flows`,
  'reports.chart-types.flows-top-paths': `Top Paths`,
  'reports.chart-types.frequency': `Frequency`,
  'reports.chart-types.funnel-frequency-bar': `Funnel Frequency Bar`,
  'reports.chart-types.funnel-frequency-line': `Funnel Frequency Line`,
  'reports.chart-types.funnel-median-ttc': `Time to Convert`,
  'reports.chart-types.funnel-steps': `Funnel Steps`,
  'reports.chart-types.funnel-top-paths': `Top Paths`,
  'reports.chart-types.funnel-trend': `Funnel Trends`,
  'reports.chart-types.funnel-ttc-bar': `Funnel Time To Convert Bar`,
  'reports.chart-types.funnel-ttc-line': `Funnel Time To Convert Line`,
  'reports.chart-types.impact-adoption': `Adoption Over Time`,
  'reports.chart-types.impact-propensity': `Causal Impact`,
  'reports.chart-types.impact-trends': `Impact Trends`,
  'reports.chart-types.line': `Line`,
  'reports.chart-types.metric': `Metric`,
  'reports.chart-types.pie': `Pie`,
  'reports.chart-types.retention-curve': `Retention Curve`,
  'reports.chart-types.retention-line': `Line`,
  'reports.chart-types.retention-trends': `Retention Trends`,
  'reports.chart-types.sankey': `User Flows`,
  'reports.chart-types.stacked-bar': `Stacked Bar`,
  'reports.chart-types.stacked-column': `Stacked Column`,
  'reports.chart-types.stacked-line': `Stacked Line`,
  'reports.chart-types.table': `Table`,
  'reports.chart-types.tooltips.bar': `Bars are best to display comparisons between categories.`,
  'reports.chart-types.tooltips.column': `Column charts display trends over time.`,
  'reports.chart-types.tooltips.flows': `Explore a fluid diagram of various user paths.`,
  'reports.chart-types.tooltips.flows-top-paths': `Specifically analyze the most often followed sequences of events.`,
  'reports.chart-types.tooltips.frequency': `The number of times a user completes a step before converting or dropping off.`,
  'reports.chart-types.tooltips.funnel-frequency-bar': ``,
  'reports.chart-types.tooltips.funnel-frequency-line': ``,
  'reports.chart-types.tooltips.funnel-median-ttc': `View a distribution of the time it takes users to convert through the funnel.`,
  'reports.chart-types.tooltips.funnel-steps': `View conversion rates between funnel steps.`,
  'reports.chart-types.tooltips.funnel-top-paths': `When using an Any Order Funnel, view which paths were most common.`,
  'reports.chart-types.tooltips.funnel-trend': `View changes in conversion rate over time.`,
  'reports.chart-types.tooltips.funnel-ttc-bar': ``,
  'reports.chart-types.tooltips.funnel-ttc-line': ``,
  'reports.chart-types.tooltips.impact-adoption': ``,
  'reports.chart-types.tooltips.impact-propensity': ``,
  'reports.chart-types.tooltips.impact-trends': ``,
  'reports.chart-types.tooltips.line': `Line charts display trends over time.`,
  'reports.chart-types.tooltips.metric': `Metric chart displays a single value for each metric.`,
  'reports.chart-types.tooltips.pie': `Pie charts illustrate composition of a whole in pie form.`,
  'reports.chart-types.tooltips.retention-curve': `View retention rates of individual cohorts of users.`,
  'reports.chart-types.tooltips.retention-line': ``,
  'reports.chart-types.tooltips.retention-trends': `View the retention trend over a period of time.`,
  'reports.chart-types.tooltips.sankey': ``,
  'reports.chart-types.tooltips.stacked-bar': `Stacked bar is best when comparing composition of multiple counts.`,
  'reports.chart-types.tooltips.stacked-column': `Stacked column charts display compositions of counts over time.`,
  'reports.chart-types.tooltips.stacked-line': `Stacked line charts display compositions of counts over time.`,
  'reports.chart-types.tooltips.table': `Tables display data in a tabular view.`,
  'settings.org-settings.verify-identity.rejected': `We couldn't confirm your identity for this change. Please try again.`,
});

__i18nScope.registerTranslationLoaders({"es": () => import("virtual:i18n-scope/es/common.report"), "fr": () => import("virtual:i18n-scope/fr/common.report"), "id": () => import("virtual:i18n-scope/id/common.report"), "ja": () => import("virtual:i18n-scope/ja/common.report"), "ko": () => import("virtual:i18n-scope/ko/common.report"), "pt": () => import("virtual:i18n-scope/pt/common.report"), "zh-CN": () => import("virtual:i18n-scope/zh-CN/common.report"), "zh-TW": () => import("virtual:i18n-scope/zh-TW/common.report")});
export default __i18nScope;
